import { useTranslation } from "react-i18next";
import {
    FrontendUserInfo,
    OrganizationInfo,
} from "node-library/dist/portal";
import { NeutralColor } from "node-library/dist/colors";
import { User } from "node-library/dist/database";
import ViewOrganizationUsersList from "./viewOrganizationUsersList";

interface Props {
    users: Array<FrontendUserInfo>;
    organization: OrganizationInfo;
    removeUser: (organization:OrganizationInfo, user: FrontendUserInfo) => void;
    gotoOrganizationDetailsPage: (organization: OrganizationInfo) => void;
    setRemoveUserModalConfirmOpen: React.Dispatch<React.SetStateAction<boolean>>;
    setProceedAction: React.Dispatch<React.SetStateAction<() => void>>;
}

export default function OrganizationUsersList(props: Props) {
    const { t: translation } = useTranslation();

    const {
        users,
        organization,
        gotoOrganizationDetailsPage,
        setRemoveUserModalConfirmOpen,
        setProceedAction,
        removeUser,
    } = props;

    return (
        <div>
            {users.length === 0 ? (
                <div style={{ flex: "1 1 0%", position: "relative", padding:"30px" }}>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            position: "absolute",
                            left: "50%",
                            top: "50%",
                            transform: "translate(-50%, -50%)",
                            gap: "5px",
                        }}
                    >
                        <div
                            className="typography-heading-01"
                            style={{ margin: "20px", color: NeutralColor.NEUTRAL_GREY_300 }}
                        >
                            {translation("NoUsers")}
                        </div>
                    </div>
                </div>
            ) : (
                <div style={{ flex: "1 1 0%", position: "relative" }}>
                    <ViewOrganizationUsersList
                        users={users}
                        organization={organization}
                        gotoOrganizationDetailsPage={gotoOrganizationDetailsPage}
                        setRemoveUserModalConfirmOpen={setRemoveUserModalConfirmOpen}
                        removeUser={removeUser}
                        setProceedAction={setProceedAction}
                    />
                </div>
            )}
        </div>
    );
}
